import Swal from 'sweetalert2'


export const showError = (msg) => {
    return Swal.fire({
        icon: "error",
        title: msg,
        customClass: {
            confirmButton: 'btn btn-primary',
            popup: "card",
            title: "text-white"
        }
    }
    );
}
export const showInfo = (msg) => {
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        }
      });
      Toast.fire({
        icon: "info",
        title: msg
      });
}

export const showLoading = (msg) => {
    Swal.fire({
        title: msg,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        customClass: {
            confirmButton: 'btn btn-primary',
            popup: "card",
            title: "text-white"
        },
        willOpen: () => {
          Swal.showLoading();
        }
      })
}

export const stopLoading = () => {
    Swal.close()
}